import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import GlobalContext from "../../../framework/GlobalContext";
import NumberInput from "../../../framework/NumberInput";

const AddDiscounts = (props) => {
  const {
    index,
    discountRowData,
    showDeleteIcon = true,
    onDeleteDiscount = () => {},
    onChange = () => {},
  } = props;

  const { setCurrentComponent } = useContext(GlobalContext);

  const getMarker = useCallback(
    (direction, rowItemIndex, rowIndex) => {
      switch (direction) {
        case "right":
          if (rowItemIndex === 0) {
            return `row_item_1_${index}`;
          }
          if (rowItemIndex === 1) {
            return `row_item_2_${index}`;
          }
          if (rowItemIndex === 2) {
            if (document.getElementById(`row_item_0_${index + 1}`)) {
              return `row_item_0_${index + 1}`;
            }
            return `row_item_2_${index}`;
          }
          break;
        case "left":
          if (rowItemIndex === 0) {
            if (document.getElementById(`row_item_0_${index - 1}`)) {
              return `row_item_2_${index - 1}`;
            }
            return `row_item_0_${index}`;
          }
          if (rowItemIndex === 1) {
            return `row_item_0_${index}`;
          }
          if (rowItemIndex === 2) {
            return `row_item_1_${index}`;
          }
          break;
        case "up":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        case "down":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        default:
          return `row_item_${rowItemIndex}_${rowIndex}`;
      }
    },
    [index]
  );

  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "delete") {
        onDeleteDiscount(index);
        return;
      }
    },
    [index, onDeleteDiscount]
  );

  useEffect(() => {
    window.addEventListener("keyup", keyupListener);
    return () => {
      window.removeEventListener("keyup", keyupListener);
    };
  }, [keyupListener]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_0_${index}`}
          autoFocus
          label="Minimum"
          value={discountRowData?.min}
          inputStyle={{
            background: "lightblue",
            flex: 1,
          }}
          onChange={(e) => onChange("min", +e.target.value)}
          onFocus={() => {
            setCurrentComponent("add_discount_slab_min");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 0, index) === "row_item_0_0"
                  ? "add_discount_slab_product_category"
                  : getMarker("up", 0, index - 1),
              down: getMarker("down", 0, index + 1),
              left:
                getMarker("left", 0, index) === "row_item_0_0"
                  ? "add_discount_slab_remarks"
                  : getMarker("left", 0, index),
              right: getMarker("right", 0, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_1_${index}`}
          label="Maximum"
          value={discountRowData?.max}
          inputStyle={{
            background: "lightblue",
            flex: 1,
          }}
          onChange={(e) => onChange("max", +e.target.value)}
          onFocus={() => {
            setCurrentComponent("add_discount_slab_max");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 1, index) === "row_item_1_0"
                  ? "add_discount_slab_branch"
                  : getMarker("up", 1, index - 1),
              down: getMarker("down", 1, index + 1),
              left: getMarker("left", 1, index),
              right: getMarker("right", 1, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_2_${index}`}
          label="Discount"
          value={discountRowData?.discPerMedicine}
          onChange={(e) => {
            const value = +e.target.value;
            if (value <= 99) {
              onChange("discPerMedicine", value);
            } else {
              onChange("discPerMedicine", 99);
            }
          }}
          onFocus={() => {
            setCurrentComponent("add_discount_slab_discount");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 2, index) === "row_item_2_0"
                  ? "add_discount_slab_remarks"
                  : getMarker("up", 2, index - 1),
              down: getMarker("down", 2, index + 1),
              left: getMarker("left", 2, index),
              right: getMarker("right", 2, index),
            }),
          }}
        />
      </div>
      {showDeleteIcon && (
        <IconButton onClick={() => onDeleteDiscount(index)}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default AddDiscounts;
